__turbopack_context__.v({
  "bgSurface": "section-layouts-module-scss-module__iA6CXG__bgSurface",
  "containerContent": "section-layouts-module-scss-module__iA6CXG__containerContent",
  "containerContentDesktop": "section-layouts-module-scss-module__iA6CXG__containerContentDesktop",
  "narrowContent": "section-layouts-module-scss-module__iA6CXG__narrowContent",
  "overflowHidden": "section-layouts-module-scss-module__iA6CXG__overflowHidden",
  "section": "section-layouts-module-scss-module__iA6CXG__section",
  "sectionAlways": "section-layouts-module-scss-module__iA6CXG__sectionAlways",
  "sectionCompact": "section-layouts-module-scss-module__iA6CXG__sectionCompact",
  "sectionHero": "section-layouts-module-scss-module__iA6CXG__sectionHero",
});
